import { create } from "zustand"
import { persist } from "zustand/middleware"
import { SentenceBaseEntity } from "@/app/entities/SentenceEntity"

interface LifeState {
  lifeSentenceData: SentenceBaseEntity | null
  setLifeSentenceData: (sentence: SentenceBaseEntity | null) => void
  clearLifeSentence: () => void
  isLifeSentence: (id: string) => boolean
}

export const useLifeStore = create<LifeState>()(
  persist(
    (set, get) => ({
      lifeSentenceData: null,
      setLifeSentenceData: (sentence) =>
        set(() => ({
          lifeSentenceData: sentence,
        })),
      clearLifeSentence: () =>
        set(() => ({
          lifeSentenceData: null,
        })),
      isLifeSentence: (id: string) => get().lifeSentenceData?.id === id,
    }),
    {
      name: "my-life-sentence-store",
      storage: {
        getItem: (name) => {
          const item = sessionStorage.getItem(name)
          return item ? JSON.parse(item) : null
        },
        setItem: (name, value) => {
          sessionStorage.setItem(name, JSON.stringify(value))
        },
        removeItem: (name) => {
          sessionStorage.removeItem(name)
        },
      },
    },
  ),
)
